module.exports = __webpack_public_path__ + "img/首页2-6.d654dcc6.svg";